import { ActionReducerMap } from '@ngrx/store';
import * as fromHotelsApp from '@store/index';
import { resultsReducer } from './results.reducer';
import * as fromResults from './results.state';

export interface IResultsState {
  results: fromResults.IResults;
}

export interface IState extends fromHotelsApp.IHotelsAppState {
  results: fromResults.IResults;
}

export const reducers: ActionReducerMap<IResultsState> = {
  results: resultsReducer,
};
